import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface Signature {
  Element: HTMLDivElement
  Args: {
    subscriptionType: SubscriptionType
  }
}

export class Copyright extends Component<Signature> {
  get copyrightYear() {
    const now = new Date()
    return now.getFullYear()
  }

  get isBlakeCopyright() {
    return (
      this.args.subscriptionType === SubscriptionType.Reading || this.args.subscriptionType === SubscriptionType.Maths
    )
  }

  <template>
    <div class="text-center text-white" ...attributes>
      {{#if this.isBlakeCopyright}}
        {{t "components.footerMain.copyrightBlake" year=this.copyrightYear}}
      {{else}}
        {{t "components.footerMain.copyright3P" year=this.copyrightYear}}
      {{/if}}
    </div>
  </template>
}
